<template>
  <div :counterTextObserver="productObserver" :id="dataCounterText">
    <div
      :dependentComputedProps="{
        getItemsFromCart,
        isFavourite,
        updateProductItem,
      }"
    ></div>
    <Observer :options="{ rootMargin: '-50px' }" :id="cardId" />
    <product-card
      :smallCards="smallCards"
      :isOnCartPage="isOnCartPage"
      :quantity="quantity"
      :cardRounded="cardRounded"
      :hideProductImg="hideProductImg"
      :imageSrc="getImageUrl(productItem)"
      :isInModal="isInModal"
      :isFavourite="isFavourite"
      :isVeg="getIsVeg(productItem)"
      :displayName="productItem?.displayName"
      :description="productItem?.description"
      :isComboItem="productItem?.comboUID"
      :currentPrice="getCurrentPrice(productItem)"
      :regularPrice="getRegularPrice(productItem)"
      :isCustomizable="isCustomizable"
      :bestseller-tag="isBestsellerTagVisible"
      :new-tag="isNewTagVisible"
      :productId="getProductSkuId()"
      :showFullInfo="showFullInfo"
      @update-show-product-card-in-modal="updateShowProductCardInModal"
      @update-favourite="updateFavourite"
      @removefromcart="removefromcart"
      @addtocart="addtocart"
      :outOfStock="isOutOfStock"
    ></product-card>
    <div
      v-if="
        false &&
        productItem?.selectedVariant?.upSell?.length > 0 &&
        quantity > 0 &&
        !isCustomizable &&
        productItem?.parentSkuId === lastInteractedProductWithUpsellId
      "
    >
      <upsell
        :type="'list'"
        :product="productItem"
        :parentProductQuantity="quantity"
      ></upsell>
    </div>
  </div>
</template>

<script setup></script>

<script>
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import ProductCard from "./ProductCard.vue";
import { EVENT_CLICK_FAVOURITE_BUTTON } from "../helpers/analyticsEvents";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";

import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility.js";
import ItemRemovePopup from "./ItemRemovePopup.vue";
import Observer from "./Observer.vue";
import GenericModal from "./GenericModal.vue";
import Upsell from "./Upsell.vue";

export default {
  name: "HongsProductCard",
  props: {
    dataItem: { required: true, default: {} },
    dataItemIndex: { required: false, default: 0 },
    dataSmallCards: { required: false, default: false },
    dataCardRounded: { required: false, default: false },
    dataHideImage: { required: false, default: false },
    dataCounterText: { required: false, default: "" },
    isInModal: { required: false, default: false },
    isOnCartPage: { required: false, default: false },
    showFullInfo: { required: false, default: false },
    dataCategoryId: { required: false, default: false },
    isOutOfStock: { required: false, default: false },
  },
  components: { ProductCard, ItemRemovePopup, GenericModal, Observer, Upsell },

  data() {
    return {
      productItem: {},
      quantity: 0,
      cardRounded: Utility.tryJsonParse(this.dataCardRounded, false),
      hideImage: Utility.tryJsonParse(this.dataHideImage, false),
      staticImgBaseUrl: staticImgBaseUrl,
      smallCards: false,
      sessionDependedMethodsProcessed: false,
      cardId: "",
      clientPlatform,
    };
  },
  created() {},
  mounted() {
    this.productItem = JSON.parse(JSON.stringify(this.dataItem));
    this.cardId =
      "prod_id_" +
      (this.productItem?.productMasterUID || this.productItem?.comboUID);
    this.smallCards = Utility.tryJsonParse(this.dataSmallCards, false);
    // console.log(this.productItem);

    if (
      this.productObserver &&
      this.dataCounterText &&
      document.getElementById(this.dataCounterText)
    ) {
      this.productObserver.observe(
        document.getElementById(this.dataCounterText)
      );
    }
  },
  updated() {
    //console.warn("updated product : ", Utility.getProductSkuId(this.dataItem));
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.dataCounterText));
    }
  },
  methods: {
    getProductSkuId() {
      return Utility.getProductSkuId(this.dataItem);
    },
    getIsVeg(productItem) {
      let lastProductItem =
        this.getLastAddedItemFromCart(
          Utility.getProductSkuId(this.productItem)
        ) || {};
      return Object.keys(lastProductItem).length
        ? lastProductItem?.isVeg
        : productItem?.isVeg;
    },
    getCurrentPrice(productItem) {
      let lastProductItem = this.getLastAddedItemFromCart(
        Utility.getProductSkuId(this.productItem)
      );
      return (
        parseFloat(
          lastProductItem?.selectedVariant?.price?.currentPrice.toFixed(2)
        ) ||
        parseFloat(lastProductItem?.price?.currentPrice.toFixed(2)) ||
        parseFloat(
          productItem?.variants
            ?.find((x) => x.defaultVariant)
            ?.price?.currentPrice.toFixed(2)
        ) ||
        parseFloat(productItem?.price?.currentPrice.toFixed(2))
      );
    },
    getRegularPrice(productItem) {
      let lastProductItem = this.getLastAddedItemFromCart(
        Utility.getProductSkuId(this.productItem)
      );
      return (
        parseFloat(
          lastProductItem?.selectedVariant?.price?.regularPrice.toFixed(2)
        ) ||
        parseFloat(lastProductItem?.price?.regularPrice.toFixed(2)) ||
        parseFloat(
          productItem?.variants
            ?.find((x) => x.defaultVariant)
            ?.price?.regularPrice.toFixed(2)
        ) ||
        parseFloat(productItem?.price?.regularPrice.toFixed(2))
      );
    },
    getImageUrl(productItem) {
      let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
      if (window.location.href?.includes("/popeyes")) {
        return (
          productItem?.variants?.find((x) => x.defaultVariant)?.mediaList?.[0]
            ?.mediaUrls?.menu ||
          mediaBaseUrl + productItem?.mediaList?.[0]?.mediaUrls?.menu ||
          staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg"
        );
      } else {
        const mediaUrl =
          productItem?.mediaList?.[0]?.mediaUrls?.HomeProductV1 ||
          productItem?.mediaList?.[0]?.mediaUrls?.Menu ||
          productItem?.mediaList?.[0]?.mediaUrls?.menu;
        return mediaUrl
          ? mediaUrl.includes("https")
            ? mediaUrl
            : mediaBaseUrl + mediaUrl
          : staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg";
      }
    },
    updateFavourite() {
      EVENT_CLICK_FAVOURITE_BUTTON();
      if (this.isFavourite) {
        if (LocalStorageFunc.isLoggedIn()) {
          this.$store.dispatch(keyMapsAction.REMOVE_FROM_FAVOURITE_API, [
            Utility.getProductSkuId(this.productItem),
          ]);
          this.$store.commit(keyMapsMutation.UNMARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
        } else {
          this.$store.commit(keyMapsMutation.UNMARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
          LocalStorageFunc.removeFromFavouriteIds({
            skuId: Utility.getProductSkuId(this.productItem),
            menuType: this.productItem?.menuType,
          });
        }
      } else {
        if (LocalStorageFunc.isLoggedIn()) {
          this.$store.dispatch(keyMapsAction.ADDTO_FAVOURITE_API, [
            {
              skuId: Utility.getProductSkuId(this.productItem),
              menuType: this.productItem?.menuType,
            },
          ]);
          this.$store.commit(keyMapsMutation.MARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
        } else {
          this.$store.commit(keyMapsMutation.MARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
          LocalStorageFunc.addToFavouriteIds({
            skuId: Utility.getProductSkuId(this.productItem),
            menuType: this.productItem?.menuType,
          });
        }
      }
    },
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    addtocart() {
      this.$store.commit(keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_CARD, {
        categoryId: this.dataCategoryId,
        index: this.dataItemIndex + 1,
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_WITH_UPSELL_ITEM,
        {
          productId: this.getProductSkuId(),
          index: this.dataItemIndex + 1,
        }
      );
      if (this.isCustomizable || this.productItem?.comboUID) {
        let cartItems = LocalStorageFunc.getCart();
        if (
          cartItems[Utility.getProductSkuId(this.productItem)] &&
          cartItems[Utility.getProductSkuId(this.productItem)].length > 0
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL,
            true
          );
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
            true
          );
        }
        this.updateShowCustomisableFor();
        return;
      }
      let product =
        this.$store.state.ProductItems.products[
          Object.keys(
            this.$store.state.ProductItems.productCategoryMap[
              Utility.getProductSkuId(this.productItem)
            ]
          )[0]
        ][Utility.getProductSkuId(this.productItem)];
      this.$store.commit(
        keyMapsMutation.ADD_TO_CART,
        product.variants?.find((x) => x.defaultVariant)
          ? {
              ...product,
              selectedVariant: product.variants?.find((x) => x.defaultVariant),
            }
          : { ...product }
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    removefromcart() {
      this.$store.commit(keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_CARD, {
        categoryId: this.dataCategoryId,
        index: this.dataItemIndex + 1,
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_WITH_UPSELL_ITEM,
        {
          productId: this.getProductSkuId(),
          index: this.dataItemIndex + 1,
        }
      );
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED,
      //     true
      // );
      let cartItems = LocalStorageFunc.getCart();
      let itemId = Utility.getProductSkuId(this.productItem);
      let editItemsListMiniCartCust = {};
      if (
        (this.productItem?.variants?.length > 0 &&
          this.productItem?.variants?.[0].attributes?.length > 0 &&
          cartItems[itemId] &&
          cartItems[itemId].length > 1) ||
        this.productItem?.comboUID
      ) {
        let cartItemsArray = Object.values(
          JSON.parse(JSON.stringify(this.$store.state.Cart.items))
        );
        let i = 0,
          j = 0;
        cartItemsArray.map((x) => {
          if (x[0]?.parentSkuId == itemId || x[0]?.skuId == itemId) {
            j = i;
            return j;
          } else {
            i++;
          }
        });
        cartItemsArray[j]?.map((item) => {
          let key = "";
          if (item?.selectedVariant) {
            let productItemID = item?.selectedVariant?.skuId;
            key = item.parentSkuId + "*" + productItemID;
          } else {
            let productItemsIdArray = item?.selectedComboVariant
              ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
              .flat();
            key = item.skuId + "*" + productItemsIdArray.join("*");
          }
          editItemsListMiniCartCust[key] = item;
        });
        if (Object.keys(editItemsListMiniCartCust).length > 1) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_EDIT_MINI_CART_MODAL,
            true
          );
          this.updateShowCustomisableFor();
        } else {
          this.$store.commit(
            keyMapsMutation.REMOVE_FROM_CART,
            this.getLastAddedItemFromCart(
              Utility.getProductSkuId(this.productItem)
            )
          );
          this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
          this.$store.commit(
            keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
            "1 Item removed from the cart."
          );
          setTimeout(this.updateDisableItemToastMsg, 1000);
        }
      } else {
        this.$store.commit(
          keyMapsMutation.REMOVE_FROM_CART,
          this.getLastAddedItemFromCart(
            Utility.getProductSkuId(this.productItem)
          )
        );
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
        this.$store.commit(
          keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
          "1 Item removed from the cart."
        );
        setTimeout(this.updateDisableItemToastMsg, 1000);
      }
    },
    updateShowCustomisableFor() {
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR,
        Utility.getProductSkuId(this.productItem)
      );
    },
    updateShowProductCardInModal() {
      //if (!this.smallCards) return;
      if (this.isOutOfStock || clientPlatform == "Web") return;
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PRODUCT_CARD_IN_MODAL_FOR,
        this.dataItem
      );
    },
    tagVisbile(tag) {
      return this.dataItem?.metadataMap?.tags?.values[0] === tag;
    },
  },
  computed: {
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.dataCounterText &&
        document.getElementById(this.dataCounterText)
      ) {
        observer.observe(document.getElementById(this.dataCounterText));
      }
      return observer;
    },
    getItemsFromCart() {
      let productItems =
        this.$store.state.Cart.items[Utility.getProductSkuId(this.productItem)];
      if (Array.isArray(productItems) && productItems.length > 0) {
        this.productItem = Utility.mergeDeep(
          productItems[productItems.length - 1],
          this.productItem
        );
        this.quantity = productItems.length;
      } else {
        this.productItem = JSON.parse(JSON.stringify(this.dataItem));
        this.quantity = 0;
      }
      return;
    },
    isFavourite() {
      return this.$store.state.ProductItems.favouriteIds[
        Utility.getProductSkuId(this.productItem)
      ];
    },
    hideProductImg() {
      return this.smallCards && this.hideImage ? true : false;
    },
    getLastAddedItemFromCart() {
      return (productId) => {
        return this.$store.getters[keyMapsGetter.GET_LAST_ADDED_ITEM_FROM_CART](
          productId
        );
      };
    },
    isBestsellerTagVisible() {
      return this.tagVisbile("BESTSELLERS");
    },
    isNewTagVisible() {
      return this.tagVisbile("NEW");
    },
    isCustomizable() {
      return this.productItem?.variants?.length > 1;
    },
    lastInteractedProductId() {
      return this.$store.state.Cart.lastInteractedProductCard?.productId;
    },
    lastInteractedProductWithUpsellId() {
      return this.$store.state.Cart.lastInteractedProductwithUpsellItem
        ?.productId;
    },
    updateProductItem() {
      this.productItem = JSON.parse(JSON.stringify(this.dataItem));
      return;
    },
  },
};
</script>

<style scoped></style>
